/**
 * API hooks для Dashboard.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
export type { ChannelStats, DailyActivity, DashboardMetrics } from '../../../shared/dashboard-contract.js';
import type { DashboardMetrics } from '../../../shared/dashboard-contract.js';
import { client } from './client';

// ============================================================================
// Types
// ============================================================================




// ============================================================================
// Hook
// ============================================================================

export function useDashboardMetrics(): UseQueryResult<DashboardMetrics, Error> {
  return useQuery({
    queryKey: ['dashboard-metrics'],
    queryFn: async () => {
      const { data } = await client.get<DashboardMetrics>('/dashboard/metrics');
      return data;
    },
    refetchInterval: 60_000, // обновление каждую минуту
  });
}
